import { useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import SideNav from "@/components/feature/SideNav";
import Footer from "@/components/feature/Footer";

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background-100">
      {/* Desktop sidebar */}
      <aside className="fixed left-0 top-0 z-40 hidden h-screen w-[260px] lg:block">
        <SideNav />
      </aside>

      {/* Mobile top bar */}
      <header className="sticky top-0 z-40 flex items-center justify-between border-b border-background-200 bg-primary-950 px-4 py-3 lg:hidden">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
            <i className="ri-movie-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-base font-bold text-background-50">出轨的味道</span>
        </Link>
        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen(true)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
        >
          <i className="ri-menu-3-line text-2xl"></i>
        </button>
      </header>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-50 lg:hidden ${menuOpen ? "" : "pointer-events-none"}`}
        aria-hidden={!menuOpen}
      >
        <div
          onClick={() => setMenuOpen(false)}
          className={`absolute inset-0 bg-primary-950/60 transition-opacity duration-300 ${
            menuOpen ? "opacity-100" : "opacity-0"
          }`}
        ></div>
        <div
          className={`absolute left-0 top-0 h-full w-[280px] max-w-[82vw] transition-transform duration-300 ${
            menuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <button
            type="button"
            aria-label="关闭导航菜单"
            onClick={() => setMenuOpen(false)}
            className="absolute right-3 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-md text-background-50/80 transition-colors hover:bg-background-50/10 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
          <SideNav onNavigate={() => setMenuOpen(false)} />
        </div>
      </div>

      {/* Main content */}
      <div className="flex min-h-screen flex-col lg:ml-[260px]">
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </div>
  );
}